import { OAuthService } from 'angular-oauth2-oidc';

import { Injectable } from '@angular/core';

import { AppInfo } from '@models/app-info.model';

@Injectable({
  providedIn: 'root',
})
export class OktaService extends OAuthService {
  async init(appInfo: AppInfo) {
    this.configure(appInfo.oktaConfig);
    await this.loadDiscoveryDocumentAndTryLogin();
    this.setupAutomaticSilentRefresh();
  }
}
